var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneCheck3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.720 5.804 C 19.665 5.826,17.231 8.232,14.310 11.151 L 9.000 16.460 6.690 14.152 C 5.411 12.874,4.330 11.825,4.267 11.802 C 4.112 11.744,3.863 11.749,3.708 11.814 C 3.537 11.885,3.335 12.121,3.282 12.309 C 3.231 12.496,3.231 12.503,3.283 12.700 C 3.320 12.837,3.698 13.233,5.953 15.494 C 7.470 17.015,8.634 18.152,8.709 18.184 C 8.873 18.256,9.127 18.256,9.291 18.184 C 9.367 18.151,11.733 15.812,15.047 12.494 C 19.937 7.597,20.679 6.839,20.717 6.700 C 20.769 6.503,20.769 6.496,20.718 6.309 C 20.665 6.121,20.463 5.885,20.292 5.814 C 20.143 5.752,19.866 5.747,19.720 5.804 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCheck3);
export default __webpack_public_path__ + "static/media/done-check-3.dcfe63d5.svg";
export { ForwardRef as ReactComponent };